module.exports = __webpack_public_path__ + "img/br3.b79e1eb4.png";